import { render, staticRenderFns } from "./QuizMap.vue?vue&type=template&id=808420cc&"
import script from "./QuizMap.vue?vue&type=script&lang=js&"
export * from "./QuizMap.vue?vue&type=script&lang=js&"
import style0 from "./QuizMap.vue?vue&type=style&index=0&id=808420cc&prod&lang=css&"
import style1 from "leaflet/dist/leaflet.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports